import { Injectable } from '@angular/core';

import { UserCharacteristics, Microenvironment, UserActivity, Intensity, UserExercise, HomeCharacteristics, HomeOperatingConditions, WeatherConditions, AirPollution, InfiltrationParameters, LocationOptions, OtherConditions } from '../models/user-inputs';

@Injectable({
  providedIn: 'root'
})
export class UserInputsService {

  // user characteristics
  userCharacteristics: UserCharacteristics = {
    sex: 2, // 1 = male, 2 = female
    age: 30,
    weight: 54.4, // kilograms
    height: 162.9, // centimeters
  }
  
  // user activity
  userActivity: UserActivity = {
    [Microenvironment.other]: 7.5, // hours
    [Microenvironment.outdoors]: 0.5, // hours
    [Microenvironment.vehicles]: 1.5, // hours
    [Microenvironment.home]: 0, // unused
  }
  
  // exercise time and intensity
  userExercise: UserExercise = {
    [Microenvironment.other]: {
      [Intensity.light]: 0, // minutes
      [Intensity.moderate]: 0, // minutes
      [Intensity.vigorous]: 0, // minutes
      [Intensity.sedentary]: 0, // unused
    },
    [Microenvironment.outdoors]: {
      [Intensity.light]: 0, // minutes
      [Intensity.moderate]: 0.5*60, // minutes
      [Intensity.vigorous]: 0, // minutes
      [Intensity.sedentary]: 0, // unused
    },
    [Microenvironment.vehicles]: {
      [Intensity.light]: 0, // minutes
      [Intensity.moderate]: 0, // minutes
      [Intensity.vigorous]: 0, // minutes
      [Intensity.sedentary]: 0, // unused
    },
    [Microenvironment.home]: {
      [Intensity.light]: 100, // minutes
      [Intensity.moderate]: 0, // minutes
      [Intensity.vigorous]: 15, // minutes
      [Intensity.sedentary]: 0, // unused
    },
  }
  
  // home characteristics
  homeCharacteristics: HomeCharacteristics = {
    floorArea: 112.0, // square meters
    yearBuilt: 1964,
    numberOfFloors: 1, // 1-3 stories
    typeOfHouse: 1, // 1 = single family, 2 = multi-family
    windShelteringOfHouse: 5, // 1 = no nearby structures, 2 = isolated rural,
    // 3 = buildings across street, 4 = urban large lots,
    // 5 = closer than 1 building height
  }
  
  // home operating conditions
  homeOperatingConditions: HomeOperatingConditions = {
    indoorTemperature: 23.8, // degrees Celcius
    numberOfWindowsOpen: 2,
    openingHeightOfWindows: 10.0, // cm
    durationWindowsOpen: 5, // hours
    numberOfDoorsOpen: 0,
    openingHeightOfDoors: 203.2, // cm
    durationDoorsOpen: 0, // hours
    numberOfWindowFansOperating: 1,
    durationWindowFansOperating: 6, // hours
    airflowOfWindowFans: 600, // cubic feet/min
    numberOfAirCleanersOperating: 1,
    durationAirCleanersOperating: 4, // hours
    cleanAirDeliveryRate: 300, // cubic feet/min
  }
  
  // weather conditions
  weatherConditions: WeatherConditions = {
    temperature: 18.4, // degrees Celcius
    windSpeed: 4.8, // km/hr
    humidity: 40, // %
  }
  
  // air pollution
  airPollution: AirPollution = {
    outdoorPM25: 10.2, // ug/m3
    outdoorOzone: 29.5, // ppb
  }
  
  // infiltration parameters
  infiltrationParameters: InfiltrationParameters = {
    penetrationCoefficientPM25Home: 0.84,
    penetrationCoefficientOzoneHome: 0.79,
    removalRatePM25Home: 0.21, // 1/hr
    removalRateOzoneHome: 2.8, // 1/hr
    infiltrationFactorPM25NotHomes: 0.64,
    infiltrationFactorPM25Vehicles: 0.44,
    infiltrationFactorOzoneNotHomes: 0.12,
    infiltrationFactorOzoneVehicles: 0.23,
  }
  
  // location options
  locationOptions: LocationOptions = {
    mode: 'auto',
    latitude: 0,
    longitude: 0,
    address: '',
  }
  
  // other conditions
  otherConditions: OtherConditions = {
    indoorHomeHumidity: 40, // %
    indoorNotHomeTemperature: 23.8, // degrees Celcius
    indoorNotHomeHumidity: 40, // %
    insideVehicleTemperature: 23.8, // degrees Celcius
    insideVehicleHumidity: 40 // %
  }

  constructor() { }
}
